import { createCachedSelector } from "re-reselect";

import type { ResultsReduxState } from "@app/types/results-redux-types";

import { getFilteredLegCards } from "./leg-cards/get-filtered-leg-cards";
import { getTripsIdsInOutage } from "./trips/get-source-outage-status";

const hasSourceOutages = (trips_ids_in_outages: string[], trip_id: string) =>
  trips_ids_in_outages.includes(trip_id);

export const getLegCardsWithoutOutageCount = createCachedSelector(
  [getFilteredLegCards, getTripsIdsInOutage],
  (filtered_leg_cards, trips_ids_in_outages) =>
    Object.values(filtered_leg_cards).filter(trip_ids => {
      // @ts-expect-error TS2345 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      return !hasSourceOutages(trips_ids_in_outages, trip_ids[0]);
    }).length
)(generateCacheKey);

/**
 * The function does not use sources_outage_status to generate the key since the content of this
 * attribute is set on the server side and its value does not change on the client side
 *
 * @param state
 * @returns
 */
function generateCacheKey(state: ResultsReduxState) {
  return Object.keys(state.trips).sort().join("");
}
